import { render, staticRenderFns } from "./KarmaCatalogueAddForm.vue?vue&type=template&id=78f7787e&scoped=true&"
import script from "./KarmaCatalogueAddForm.vue?vue&type=script&lang=js&"
export * from "./KarmaCatalogueAddForm.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCatalogueAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaCatalogueAddForm.vue?vue&type=style&index=1&id=78f7787e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f7787e",
  null
  
)

export default component.exports